import component from './HotelSearchResultsWrapper';

export default component;
